type Props = {
    speakerIndex: number;
    text: string;
};

export function TranscriptRow({ speakerIndex, text }: Props) {
    return (
        <>
            <p>S{speakerIndex + 1}</p>
            <p>{text}</p>
        </>
    );
}
